import { Request } from '../../../httpClient/serverApi/requests/Request';

export class GetFeatureValueRequest extends Request<Object, any> {
  constructor(serviceName: string, defaultValue: string) {
    super('getFeatureValue', {
      'featureName' : serviceName,
      'defaultValue': defaultValue, // this value have been calculated based on the feature flag
    });
  }
}
